const narrativeFairValueType = [
  'base',
  'legacy',
  'analysts',
  'user_defined',
  'dcf',
  null,
] as const;

export type NarrativeFairValueType = (typeof narrativeFairValueType)[number];

export const isNarrativeFairValueType = (
  type: unknown
): type is NarrativeFairValueType =>
  narrativeFairValueType.includes(type as NarrativeFairValueType);
